// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router-link-button-wrapper[data-v-6c733ad2] {\n  margin-right: 10px;\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
